import axios from 'axios'

const callaxios = axios.create({
	baseURL: "http://34.199.176.17:13051",
	headers:{
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin' : "http://34.199.176.17:13051",
        'Access-Control-Allow-Methods' :  "POST, GET, OPTIONS, PUT, DELETE",
        'Access-Control-Allow-Headers' :  "Content-Type, X-Auth-Token, Origin, Authorization, UserId"
    },
    mode: 'no-cors'
    
});

// configure headers
callaxios.interceptors.request.use(
    config =>
  {
    if(sessionStorage.getItem("LOGGEDIN")){
        config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('JWT');
        config.headers['UserId'] = sessionStorage.getItem('userEmail');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
)


export default callaxios